import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import About from "./pages/About";
import Collection from "./pages/Collection";
import NewCollection from "./pages/NewCollection"; // ✅ Capitalized correctly
import Contact from "./pages/Contact";
import ScrollToTop from "./pages/ScrollToTop"; // ✅ import

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ✅ always scroll to top on refresh or route change */}
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/newcollection" element={<NewCollection />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </Router>
  );
}

export default App;
